import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=17f391b8&scoped=true&"
import script from "./Impressum.vue?vue&type=script&lang=js&"
export * from "./Impressum.vue?vue&type=script&lang=js&"
import style0 from "./Impressum.vue?vue&type=style&index=0&id=17f391b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f391b8",
  null
  
)

export default component.exports